import type { AccessLabels } from '@kizen/permissions/types';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import { GridContainer, HeaderToggles } from './styled';

type SectionContentProps = {
  children?: ReactNode;
  labels?: AccessLabels;
};

const EMPTY_LABELS: AccessLabels = ['', '', '', ''];

export const SectionContent = (props: SectionContentProps) => {
  const { t } = useTranslation();

  const { labels = EMPTY_LABELS, children } = props;

  return (
    <>
      <GridContainer marginBottom="17">
        <KizenTypography weight="bold">{t('Permission Area')}</KizenTypography>
        <HeaderToggles>
          <KizenTypography as="span" weight="bold">
            {labels[0] || t('None')}
          </KizenTypography>
          <KizenTypography as="span" weight="bold">
            {labels[1] || t('View')}
          </KizenTypography>
          <KizenTypography as="span" weight="bold">
            {labels[2] || t('Create/Edit')}
          </KizenTypography>
          <KizenTypography as="span" weight="bold">
            {labels[3] || t('Delete/All')}
          </KizenTypography>
        </HeaderToggles>
      </GridContainer>
      {children}
    </>
  );
};
